import * as d3 from 'd3-format';

// [d3 format, unit, full name, icon] 
const valuesFormat = {
    name:          [null, null, 'Region name', 'icon-location'],
    dist_agent:         [',.2s', 'm', 'Distance to nearest agent', null],
    type_env:           [null, null, 'City type', 'icon-building'],
    business :          [null, null, 'Type of business', 'icon-shop'],
    gender:             [null, null, 'Gender', 'icon-gender'],
    jc_id:              [null, null, 'JC ID', 'icon-user'],
    population:         [',.0f', null, 'Total population', 'icon-users'],
    nb_agent:           [',.0f', null, 'Total number of agents', 'icon-phone'],
    pop_per_agent:      [',.0f', null, 'Population per agent', 'icon-balance'],
    jc_pen:             [',.3f', null, 'Penetration of JazzCash usage', null],
    gsm_pen:            [',.3f', null, 'Penetration of Jazz GSM usage', null],
    jc_pen_by_gsm :     [',.3f', null, 'Penetration of JazzCash over GSM usage', null],
    agent_per_pop :     [',0f', null, 'Agent per inhabitant', 'icon-balance'],
    jc_customers :      [',.0f', null, 'JazzCash customers', null],
    jc_per_agent :      [',.0f', null, 'JazzCash customers per agent', null],
    gsm_per_agent :     [',.0f', null, 'Jazz GSM customers per agent', null],
    gsm_customers :     [',.0f', null, 'Jazz GSM customers', null],
    city:               [null, null, 'City', 'icon-building'],
    business_name:      [null, null, 'Business name', 'icon-shop'],
    agent_type:         [null, null, 'Agent type', 'icon-shop'],
    pct_p_2g:           [',.0f', '%', 'Population access to 2G', null],
    pct_p_3g:           [',.0f', '%', 'Population access to 3G', null],
    pct_p_4g:           [',.0f', '%', 'Population access to 4G', null],
    pop_2g:             [',.0f', null, 'Access to 2G', null],
    pop_3g:             [',.0f', null, 'Access to 3G', null],
    pop_4g:             [',.0f', null, 'Access to 4G', null],
    covered_2g:         [null, null, 'Covered by 2G', null],
    covered_3g:         [null, null, 'Covered by 3G', null],
    covered_4g:         [null, null, 'Covered by 4G', null],
    mm_customers:       [',.0f', null, "Mobile Money customers", null],
    mm_pen:             [',.3f', null, "Penetration for Mobile Money usage", null],
    mm_pen_by_gsm:      [',.3f', null, "Penetration for Mobile Money over GSM usage", null],
    gsm_pen_cd:         [',.3f', null, "Penetration for GSM usage", null],
    mm_per_agent:       [',.0f', null, "Mobile Money customers per agent", null],
    gsm_customers_cd:   [',.0f', null, "GSM customers", null],
    gsm_per_agent_cd:   [',.0f', null, "GSM customers per agent", null],
    master_age:         [null, null, "Master agent", null],
    status:             [null, null, "Status", null],
    site_name:          [null, null, "Site name", null],
};

function format(key, value) {
    if (!(key in valuesFormat)) return [key, value];
    const formats = valuesFormat[key];
    let formatted = value;
    if (formats[0]) formatted = d3.format(formats[0])(value);
    if (formats[1]) formatted += formats[1];
    return [formats[2], { 'icon': formats[3], 'value': formatted }];
}

function formatObject(obj, discardUnspecified = false) {
    return Object.keys(obj).reduce( (prev,key) => {
        const [name, val] = format(key, obj[key]);
        if (val == obj[key] && discardUnspecified) return prev;
        prev[name] = val;
        return prev;
    }, {});
}


export {formatObject};